import React from 'react';
import { Button, Dialog, Group } from '@economic/taco';
import { Trans } from '@lingui/macro';
import imgShakingHands from '~/app/pages/market/onboarding/CustomerPayments/assets/man-and-woman-shaking-hands.png';
import ExternalLink from '~/app/shared/components/ExternalLink';

interface Props {
    hide: () => void;
}

const ConnectedToPensoPay = ({ hide }: Props) => {
    return (
        <>
            <Dialog.Title>
                <Trans>You are good to go</Trans>
            </Dialog.Title>

            <div className="flex mt-4 justify-center">
                <img src={imgShakingHands} alt="" />
            </div>

            <div className="flex mt-8">
                <Trans>
                    You have now completed the first part of the Payment Link setup. You can now add payment links to your
                    invoices via "New invoice".
                </Trans>
            </div>

            <div className="flex flex-col mt-4">
                <strong>
                    <Trans>IMPORTANT</Trans>
                </strong>
                <span>
                    <Trans>
                        You will soon receive an email from pensopay with a link to a KYC (know your customer) application
                    </Trans>
                </span>
            </div>

            <div className="flex mt-4">
                <span>
                    <Trans>
                        You must submit the application within 30 days and be approved by pensopay before you can receive payments
                        from your customers.
                    </Trans>
                </span>
            </div>

            <div className="flex mt-4">
                <span>
                    <Trans>In the meantime, you can read more about how to use</Trans>{' '}
                    <ExternalLink href="#Payment-Link-in-e-copedia">
                        <Trans>Payment Link in e-copedia.</Trans>
                    </ExternalLink>
                </span>
            </div>

            <Group className="flex mt-6 justify-end">
                <Button appearance="primary" onClick={hide}>
                    <Trans>Done</Trans>
                </Button>
            </Group>
        </>
    );
};

export default ConnectedToPensoPay;
